<template>
    <div class="about mobile">
      <mHead :classType="'light'" :showSearch="true"></mHead>
      <div class="main">
          <div class="company">
                <div class="leftTitle">
                    公司简介
                </div>
                <div class="content">
                    <img v-for="(item, index) in imgListTop" :src="item.url" :key="index + 'top'" alt="">
                    <div class="info">
                        <p class="address">
                            <img src="@/assets/img/Group 158@2x.png" alt="">
                            <span>{{company.address}}</span>
                        </p>
                        <p class="phone">
                            <img src="@/assets/img/Group 159@2x.png" alt="">
                            <span>{{company.phone}}</span>
                        </p>
                    </div>
                    <p class="line"></p>
                    <div class="aboutDiv" v-html="company.about"></div>
                    <div class="mission">
                        <div class="item">
                            <img src="@/assets/img/Group 144@2x.png" alt="">
                            <p class="first">使命</p>
                            <p>用创意输出价值</p>
                            <p>用营销赋能品牌</p>
                            
                        </div>
                        <div class="item">
                            <img src="@/assets/img/Group 145@2x.png" alt="">
                            <p class="first">愿景</p>
                            <p>成为全球领先的</p>
                            <p>数字创意科技公司</p>
                        </div>
                    </div>
                    <div class="mission">
                        <div class="item">
                            <img src="@/assets/img/Group 146@2x.png" alt="">
                            <p class="first">价值观</p>
                            <p>梦想、信任</p>
                            <p>成长、分享</p>
                        </div>
                    </div>
                </div>
          </div>
          <p class="line"></p>
            <div class="person">
                <div class="leftTitle">
                    核心成员
                </div>
                <div class="content">
                    <div class="personList">
                        <!-- <div class="item" v-for="item in personList" :key="item.name" @click="toDetail(item.name)">
                            <img :src="item.imageUrl" alt="">
                            <div class="personDiv">
                                <p>{{ item.name }}</p>
                                <p>{{ item.position }}</p>
                                <img src="@/assets/img/Group 70@2x.png" alt="">
                            </div>
                        </div> -->
                        <swiper v-if="personList.length>0" :options="swiperOption" ref="mySwiper">
                            <swiper-slide v-for="(item,index) in personList" :key="index">
                                <div class="item" @click="toDetail(item.name)">
                                    <img :src="item.imageUrl" alt="">
                                    <div class="personDiv">
                                        <p>{{ item.name }}</p>
                                        <p>{{ item.position }}</p>
                                        <img src="@/assets/img/Group 70@2x.png" alt="">
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
            </div>
            <p class="line"></p>
            <div class="person">
                <div class="leftTitle">
                    公司文化
                </div>
                <div class="content">
                    <div class="imgList">
                        <img :src="item.url" alt="" v-for="item in civilizationList" :key="item.url">
                    </div>
                </div>
            </div>
            <p class="line"></p>
            <div class="person">
                <div class="leftTitle">
                    办公环境
                </div>
                <div class="content">
                    <div class="imgList">
                        <img :src="item.url" alt="" v-for="item in environmentList" :key="item.url">
                    </div>
                </div>
            </div>
      </div>
      <mBottom :classType="'light'"></mBottom>
    </div>
</template>
<script>
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
    components:{ mHead, mBottom, swiper, swiperSlide },
    data() {
        return {
            swiperOption:{
                slidesPerView: 'auto',
                speed: 300,
                autoplay: true,
                loop: true,
                observer: true,
                observeParents: true,
            },
            imgListTop: [],
            company: {
                address: '',
                phone: '',
                about: ''
            },
            imgListBottom: [],
            environmentList: [],
            civilizationList: [],
            personImg: {
                url: ''
            },
            personList: [
                
            ]
        }
    },
    mounted(){
        this.getList();
        this.statistics();
    },
    beforeDestroy(){
        
    },
    methods: {
        toDetail(id){
            this.$router.push('/person/'+id)
        },
        statistics(){
            this.$http.post(this.service.dev.api.statistics, {pageName: '了解青橙'} ).then(response =>{
              
            })
        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=9' ).then(response =>{
                if(response.status == 200){
                    let list = response.body || []
                    if(list.length > 0){
                        list.map(item => {
                            if(item.keyName == 'imgListTop'){
                                let urlList = item.content.split(',')
                                let heightList = item.keyDesc.split(',')
                                urlList.map((em,ind) => {
                                    this.imgListTop.push({ height: heightList[ind], url: em})
                                })
                            } else if (item.keyName == 'company') {
                                this.company = JSON.parse(item.content);
                            } else if(item.keyName == 'environmentList'){
                                let urlList = item.content.split(',')
                                let heightList = item.keyDesc.split(',')
                                urlList.map((em,ind) => {
                                    this.environmentList.push({ height: heightList[ind], url: em})
                                })
                            } else if(item.keyName == 'civilizationList'){
                                let urlList = item.content.split(',')
                                let heightList = item.keyDesc.split(',')
                                urlList.map((em,ind) => {
                                    this.civilizationList.push({ height: heightList[ind], url: em})
                                })
                            } else if(item.keyName == 'imgListBottom'){
                                let urlList2 = item.content.split(',')
                                let heightList2 = item.keyDesc.split(',')
                                urlList2.map((em,ind) => {
                                    this.imgListBottom.push({ height: heightList2[ind], url: em})
                                })
                            } else if(item.keyName == 'personImg') {
                                this.personImg.url = item.content;
                                this.personImg.height = item.keyDesc;
                            } else if(item.keyName == 'personList') {
                                this.personList = JSON.parse(item.content || '[]')
                            }
                        })
                    }
                } else {
                    this.$message.error(response.message?response.message:'error');
                }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/base.scss";
    .about {
        background: #FAFAFA;
        .main {
            .line {
                position: relative;
                &:after {
                    position: absolute;
                    box-sizing: border-box;
                    content: " ";
                    pointer-events: none;
                    right: 1px;
                    bottom: 0;
                    left: poToRem(20);
                    border-bottom: 1px solid rgba(0,0,0,0.1);
                    transform: scaleY(.5);
                }
            }
            .company {
                .leftTitle {
                    margin-top: poToRem(36);
                    padding-top: poToRem(20);
                }
            }
            .person,.company {
                position: relative;
                // border-bottom: poToRem(1) solid rgba(0,0,0,0.1);
                margin-bottom: poToRem(80);
                padding-top: poToRem(20);
            }
            .leftTitle {
                font-size: poToRem(24);
                text-align: left;
                padding-bottom: poToRem(20);
                padding-left: poToRem(20);
            }
            .content {
                img {
                    width: 100%;
                    display: block;
                }
                .info {
                    padding: poToRem(20) poToRem(20) poToRem(80) poToRem(20);
                    width: 100%;
                    box-sizing: border-box;
                    // border-bottom: poToRem(1) solid rgba(0,0,0,0.1);
                    .address,.phone {
                        text-align: left;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        &:first-child {
                            margin-bottom: poToRem(8);
                        }
                        img {
                            width: poToRem(20);
                            height: poToRem(20);
                        }
                        span {
                            font-size: poToRem(14);
                            color: rgba(0,0,0,0.6);
                            vertical-align: super;
                            margin-left: poToRem(8);
                        }
                    }
                }
                .aboutDiv {
                    margin-top: poToRem(20);
                    margin-bottom: poToRem(40);
                    padding: 0 poToRem(20);
                }
                .mission {
                    display: flex;
                    margin-bottom: poToRem(20);
                    padding: 0 poToRem(20);
                    &:last-child {
                        margin-bottom: poToRem(80);
                    }
                    .item {
                        width: 50%;
                        position: relative;
                        p {
                            font-size: poToRem(16);
                            line-height: poToRem(30);
                            color: rgba(0,0,0,0.6);

                            text-align: left;
                            &.first {
                                font-size: poToRem(20);
                                color: rgba(0,0,0,0.8);
                                margin-bottom: poToRem(2);
                            }
                        }
                        img {
                            width: poToRem(24);
                            height: poToRem(24);
                            display: block;
                            margin-bottom: poToRem(10);
                        }
                    }
                }
                .personList {
                    text-align: left;
                    padding: 0 poToRem(57);
                    overflow: hidden;
                    .swiper-container {
                        overflow: visible;
                    }
                    .item {
                        cursor: pointer;
                        // width: calc(100% - 134px);
                        padding: 0 poToRem(10);
                        >img {
                            width: 100%;
                            display: block;
                        }
                        .personDiv {
                            padding: poToRem(20);
                            height: poToRem(140);
                            box-sizing: border-box;
                            background: #ffffff;
                            position: relative;
                            p {
                                line-height: poToRem(32);
                                font-size: poToRem(16);
                                color: rgba(0,0,0,0.6);
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                width: 100%;
                                &:first-child {
                                    line-height: poToRem(24);
                                    font-size: poToRem(20);
                                    color: rgba(0,0,0,1);
                                }
                            }
                            img {
                                position: absolute;
                                right: poToRem(24);
                                bottom: poToRem(24);
                                width: poToRem(18);
                                display: block;
                            }
                        }
                    }
                }
                .imgList {
                    width: 100%;
                    padding: 0 poToRem(20);
                    box-sizing: border-box;
                    // margin-bottom: 120px;
                    img {
                        width: 100%;
                        display: block;
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
@import "@/assets/style/base.scss";
   .about {
       &.mobile {
           .main {
                .aboutDiv {
                    p {
                        font-size: poToRem(16);
                        line-height: poToRem(32);
                        color: rgba(0,0,0,0.6);
                    }       
                }
            
            }
       }
   }
</style>





// WEBPACK FOOTER //
// src/modules/view/about/mobile.vue